import { Box } from '@mui/material'
import { FC } from 'react'
import { appTileColor } from '../../layout/theme/color'

type TileColor = keyof typeof appTileColor

interface AppTileProps {
  /** 1-3 characters, e.g. "Ce". */
  abbreviation: string
  color?: TileColor
  /** Edge length in px. */
  size?: number
  title?: string
}

/**
 * Application tile like the "Applicaties" menu on xxllnc.nl: a rounded square
 * (radius ~22% of its size) with the abbreviation, coloured by product group.
 */
export const AppTile: FC<AppTileProps> = ({ abbreviation, color = 'orange', size = 28, title }) => {
  // eslint-disable-next-line security/detect-object-injection -- closed union key
  const { bg, fg } = appTileColor[color]
  return (
    <Box
      component="span"
      role="img"
      aria-label={title ?? abbreviation}
      title={title}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: `${Math.round(size * 0.22)}px`,
        bgcolor: bg,
        color: fg,
        fontWeight: 600,
        fontSize: Math.round(size * (abbreviation.length > 2 ? 0.36 : 0.42)),
        lineHeight: 1,
        letterSpacing: '-0.01em',
        userSelect: 'none',
      }}
    >
      {abbreviation}
    </Box>
  )
}
